import React from 'react';

interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large';
    color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
    size = 'medium', 
    color = 'currentColor' 
}) => {
    const sizeMap = {
        small: '24',
        medium: '32',
        large: '48'
    };

    return (
        <div className="spinner-container">
            <svg
                width={sizeMap[size]}
                height={sizeMap[size]}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className="spinner-svg"
            >
                <circle
                    className="spinner-circle"
                    cx="12"
                    cy="12"
                    r="10"
                    fill="none"
                    stroke={color}
                    strokeWidth="3"
                />
            </svg>
        </div>
    );
};

export default LoadingSpinner; 